import { InputProps, Input } from 'antd';
import { PasswordProps } from 'antd/lib/input';
import { FormikValues, useField } from 'formik';
import React from 'react';
import { useFormikFormContext } from '../FormikFormContext';

export interface IPasswordInputProps<T extends FormikValues>
  extends Omit<PasswordProps, 'name'> {
  name: keyof T & string;
}

export function PasswordInput<T extends FormikValues>(
  props: IPasswordInputProps<T>
) {
  const { name } = props;
  const [field, meta] = useField(name);
  const { disabled } = useFormikFormContext();

  return (
    <Input.Password
      {...field}
      {...props}
      disabled={props.disabled || disabled}
    />
  );
}
